import { Alert } from 'reactstrap';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

export const makeCall = (phoneNumber: string) => {
    logEvent(analytics, 'phone_call_web', {
        name: 'phone call',
        description: 'User called a number'
    });

    console.log(phoneNumber);
    
    window.location.href = `zoomphonecall://${phoneNumber}`;

    // const handleText = async () => {
    //     Linking.openURL(`sms:${phoneNumber}`)

    //     await logEvent(analytics, 'text_msg', {
    //         name: 'text message',
    //         description: 'User sent an sms message'
    //     });
    // };

    // Linking.canOpenURL(url)
    // .then((supported) => {
    //     if (supported) {
    //         Alert.alert(
    //             "Contact Options",
    //             "Choose a contact method.",
    //             [
    //                 {
    //                     text: "Call",
    //                     onPress: handleCall
    //                 },
    //                 {
    //                     text: "Text",
    //                     onPress: handleText
    //                 },
    //                 {
    //                     text: "Cancel",
    //                     style: "cancel",
    //                 },
    //             ],
    //             { cancelable: true }
    //         )
    //     } else {
    //         Alert.alert('Call Error', 'Phone Calls are not supported on this device', [
    //             {
    //                 text: 'Cancel',
    //                 onPress: () => console.log('Cancel Pressed'),
    //                 style: 'cancel'
    //             },
    //             {
    //                 text: 'OK',
    //                 onPress: () => console.log('OK Pressed')
    //             },
    //         ]);
    //     }
    // }) .catch((err) => console.log('An error occurred', err));
}